import { Typography } from '@snack-uikit/typography';

import { LoadingOverlay } from '@/components/static/LoadingOverlay/LoadingOverlay';
import { CategoryDataItem } from '@/types/serp';
import { isEmpty, isNil } from '@/utils/common';

import { SearchItem } from './SearchItem';
import s from './styles.module.scss';

export function SearchResults({
  articles,
  isLoading,
  isAllPlatformsSelected,
  selectedPlatforms,
}: {
  articles: CategoryDataItem[] | null;
  isLoading?: boolean;
  isAllPlatformsSelected: boolean;
  selectedPlatforms: string[];
}) {
  if (isNil(articles)) {
    return null;
  }

  if (isEmpty(articles) && !isLoading) {
    return (
      <div className={s.nothing_found_wrapper}>
        <Typography.SansLabelL className={s.notching_found_title}>
          По вашему запросу ничего не найдено
        </Typography.SansLabelL>
        <Typography.SansTitleM> Попробуйте изменить запрос </Typography.SansTitleM>
      </div>
    );
  }

  return (
    <LoadingOverlay isLoading={isLoading}>
      <div className={s.search_items_wrapper}>
        {articles.slice(0, 5).map(article => (
          <SearchItem
            isAllPlatformsSelected={isAllPlatformsSelected}
            selectedPlatforms={selectedPlatforms}
            key={article.link + article.title}
            article={article}
          />
        ))}
      </div>
    </LoadingOverlay>
  );
}
